import React, { useState, useEffect } from 'react';
import { Card, Row, Col, Statistic, Spin, Avatar } from 'antd';
import { FileTextOutlined, DollarOutlined, UserOutlined, WalletOutlined } from '@ant-design/icons';
import { get } from '../../utils/merchantApi';

const MerchantDashboard = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [data, setData] = useState(null);

  useEffect(() => {
    get('/merchant/stats')
      .then(res => {
        setData(res.data);
      })
      .catch(err => {
        console.error(err);
        setError(err.message);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  if (loading) {
    return <div style={{ textAlign: 'center', padding: 100 }}><Spin size="large" /></div>;
  }

  if (error) {
    return <div style={{ textAlign: 'center', padding: 100, color: 'red' }}>Error: {error}</div>;
  }

  return (
    <div>
      <Card style={{ marginBottom: 16 }}>
        <Row gutter={16} align="middle">
          <Col>
            <Avatar size={64} icon={<UserOutlined />} style={{ backgroundColor: '#1890ff' }} />
          </Col>
          <Col>
            <div style={{ fontSize: 18, fontWeight: 'bold' }}>
              {data?.user?.real_name || data?.user?.phone || data?.user?.email || '商户用户'}
            </div>
            <div style={{ color: '#666', marginTop: 4 }}>
              登录账号: {data?.user?.phone || data?.user?.email || '-'}
            </div>
            <div style={{ color: '#666' }}>
              用户ID: {data?.user?.id}
            </div>
          </Col>
          <Col style={{ marginLeft: 'auto' }}>
            <Row gutter={32}>
              <Col>
                <div style={{ textAlign: 'center' }}>
                  <div style={{ color: '#666', fontSize: 12 }}>账户余额</div>
                  <div style={{ fontSize: 24, color: '#52c41a', fontWeight: 'bold' }}>
                    ¥{Number(data?.user?.balance || 0).toFixed(2)}
                  </div>
                </div>
              </Col>
              <Col>
                <div style={{ textAlign: 'center' }}>
                  <div style={{ color: '#666', fontSize: 12 }}>冻结余额</div>
                  <div style={{ fontSize: 24, color: '#faad14', fontWeight: 'bold' }}>
                    ¥{Number(data?.user?.frozen_balance || 0).toFixed(2)}
                  </div>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Card>

      <h2>商户数据统计</h2>
      <Row gutter={16}>
        <Col span={6}>
          <Card>
            <Statistic title="今日订单" value={data?.today?.order_count || 0} prefix={<FileTextOutlined />} />
          </Card>
        </Col>
        <Col span={6}>
          <Card>
            <Statistic title="今日交易额" value={data?.today?.total_amount || 0} precision={2} prefix={<DollarOutlined />} />
          </Card>
        </Col>
        <Col span={6}>
          <Card>
            <Statistic title="本周订单" value={data?.this_week?.paid_count || 0} prefix={<FileTextOutlined />} />
          </Card>
        </Col>
        <Col span={6}>
          <Card>
            <Statistic title="本周交易额" value={data?.this_week?.total_amount || 0} precision={2} prefix={<DollarOutlined />} />
          </Card>
        </Col>
      </Row>
      <Row gutter={16} style={{ marginTop: 16 }}>
        <Col span={6}>
          <Card>
            <Statistic title="本月订单" value={data?.this_month?.paid_count || 0} prefix={<FileTextOutlined />} />
          </Card>
        </Col>
        <Col span={6}>
          <Card>
            <Statistic title="本月交易额" value={data?.this_month?.total_amount || 0} precision={2} prefix={<DollarOutlined />} />
          </Card>
        </Col>
        <Col span={6}>
          <Card>
            <Statistic title="已结算总笔数" value={data?.settlements?.paid_count || 0} />
          </Card>
        </Col>
        <Col span={6}>
          <Card>
            <Statistic title="已结算总额" value={data?.settlements?.total_settle_amount || 0} precision={2} prefix={<DollarOutlined />} />
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default MerchantDashboard;
